import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { StaticQuery, graphql } from "gatsby"
import { injectIntl } from 'react-intl'

import shareImage from '../images/iid-share.jpg'

function SEO({ description, meta, keywords, title, bodyClass, noIndex, intl: {locale, formatMessage, messages} }) {
  // Traduci il titolo se c'è e se esiste una traduzione, altrimenti lascialo com'è senza warning
  const translatedTitle = title ? (messages[title] ? formatMessage({ id: title }) : title) : undefined;
  return (
    <StaticQuery
      query={detailsQuery}
      render={data => {
        const { siteMetadata } = data.site;
        const translatedDescription = siteMetadata.descriptions.find(desc => desc.lang === locale);
        const metaDescription =
          description || (translatedDescription ? translatedDescription.text : '') || siteMetadata.description;
        const formattedTitle = translatedTitle ? `${translatedTitle} | ${siteMetadata.title}` : siteMetadata.title;
        return (
          <Helmet
            htmlAttributes={{
              lang: locale,
            }}
            bodyAttributes={
              { class : bodyClass}
            }
            title={formattedTitle}
            meta={[
              {
                name: `description`,
                content: metaDescription,
              },
              {
                property: `og:title`,
                content: formattedTitle,
              },
              {
                property: `og:description`,
                content: metaDescription,
              },
              {
                property: `og:type`,
                content: `website`,
              },
              {
                name: `twitter:card`,
                content: `summary`,
              },
              {
                name: `twitter:title`,
                content: formattedTitle,
              },
              {
                name: `twitter:description`,
                content: metaDescription,
              },
              {
                property: `og:image`,
                content: `${siteMetadata.siteUrl}${shareImage}`,
              },
              {
                property: `og:image:type`,
                content: 'jpg',
              },
              {
                property: `og:image:width`,
                content: '1900',
              },
              {
                property: `og:image:height`,
                content: '930',
              },
            ]
              .concat(
                keywords.length > 0
                  ? {
                      name: `keywords`,
                      content: keywords.join(`, `),
                    }
                  : []
              ).concat(
                noIndex ? 
                {
                  name: `ROBOTS`,
                  content: `NOINDEX, FOLLOW`
                } 
              : [])
              .concat(meta)}
          />
        )
      }}
    />
  )
}

SEO.defaultProps = {
  meta: [],
  keywords: [],
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.array,
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string,
}

export default injectIntl(SEO);

const detailsQuery = graphql`
  query DefaultSEOQuery {
    site {
      siteMetadata {
        title
        siteUrl
        description
        descriptions {
          text
          lang
        }
      }
    }
  }
`
